import cx from "classnames";
import React from "react";

import { Column, format, Row } from "@gamedev-web/gamedev-sdk-core";

import { useStrings } from "../../localization/localizationHelpers";
import { SubFormsRenderingModel } from "../../models/sharedFormsModels";
import * as styles from "./FormHeader.module.css";

type FormHeaderProps = Readonly<{
  subFormsMetadata: ReadonlyDictionary<SubFormsRenderingModel>;
  currentSubFormId: string;
  subFormsIdsOrder: string[];
  mainFormTitle: string;
}>;

export const FormHeader = (props: FormHeaderProps) => {
  const { subFormsMetadata, currentSubFormId, subFormsIdsOrder, mainFormTitle } = props;
  const currentSubForm = subFormsMetadata[currentSubFormId];
  const stepNumber = subFormsIdsOrder.findIndex(elem => elem === currentSubFormId) + 1;
  const [formStepNoteFormat, requiredFieldsSideNote] = useStrings(
    "formStepNoteFormat",
    "requiredFieldsSideNote"
  );
  const formStepNote = format(
    formStepNoteFormat,
    stepNumber.toString(),
    subFormsIdsOrder.length.toString()
  );
  return (
    <div className={styles.formHeader}>
      <Column className={styles.columnWrapper}>
        <Row>
          <Column>
            <h1 className={styles.title}>{currentSubForm.title}</h1>
          </Column>
        </Row>
        <Row className={styles.formHeaderSubFormContent}>
          <Column className={cx(styles.bottomAligned, styles.formStepsGroup)}>
            <h2 className={styles.mainFormTitle}>{mainFormTitle}</h2>
            <p className={cx(styles.subtitle, styles.bottomAligned)}>{formStepNote}</p>
          </Column>
          <Column className={styles.bottomAligned}>
            <p className={cx(styles.subtitle, styles.fieldsRequiredNote)}>
              {requiredFieldsSideNote}
            </p>
          </Column>
        </Row>
      </Column>
    </div>
  );
};
